module.exports = __webpack_public_path__ + "img/17_106.711c6d07.png";